/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import { AppCSS, Spacer, TxtInput, ChkInputBox } from "../../../../components";
import { Lbl } from "../../../../components/labels";
import { ColDiv, RowDiv } from "../../../../components/misc/misc.styled";

import * as React from "react";
import { useDispatch } from "react-redux";
import { Container } from "../../../../globalstyled";

import { Box, Typography, TextField, Autocomplete } from "@mui/material";

import plusIcon from "../../../../images/PlusIcon.png";
import deleteIcon from "../../../../images/DeleteIcon.png";
import searchIcon from "../../../../images/searchIcon.png";

import LeadsTableHeaderCard from "../../../../components/table/CustomTableHeaderCard";
import { NumericFormat } from "react-number-format";
import MaterialItemsDrawer from "../SideDrawer/index";
import {
  ArrowIcon,
  FormTitleTypography,
  StandardIcon,
} from "../itemCreation.styled";
import UpArrowIcon from "../../../../images/UploadIcon.png";
import DownArrowIcon from "../../../../images/DownloadIcon.png";

import LeadsTableBodyCard from "../../../../components/table/CustomTableBodyCard";
import PicturesTableWithoutHeader from "../../../../components/table/CustomTableBodyCardWithoutHeader";

import {
  MATERIAL_ITEMS_TABLE_HEADER_LIST,
  MATERIAL_ITEMS_PICTURES_TABLE_ROW_HEADER_LIST,
} from "../../../../contants/dashboardHeader";

import {
  MaterialItems,
  MaterialMeasurements,
  Tag,
} from "../../../../redux/types/creation";
import { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logEvent, ITEM_CREATION_EVENTS } from "../../../../utils/amplitude";
import { SFileUpload } from "../../../../components/input/input.styled";
import { FileOpen } from "@mui/icons-material";
import TableViewDetails from "../../../../components/table/TableViewDetails";
import CancelAndSubmitButtons from "../ItemCreationComponent/SubmitAndCancelButton";
import SideDrawerHeader from "../SideDrawer/SideDrawerHeader";
import SearchAndCreateComponent from "../ItemCreationComponent/SearchAndCreateComponent";
import Pagination from "../ItemCreationComponent/Pagination";
import MaterialItemsProductSystemTableWithoutHeader from "../../../../components/table/CustomTableBodyCardWithoutHeader";
import ViewRowDetailsDrawer from "../ItemCreationComponent/ViewFieldDetails";
import {
  CHECK_MATERIAL_QUALITY,
  MATERIAL_ITEMS_DRAWER_DETAILS,
} from "../../../../contants/itemsCreation";
import EmptyTable from "../../../../components/table/EmptyTable";
import {
  useArchiveMaterial,
  useCreateMaterial,
  useUpdateMaterial,
} from "../../../../apolloClient/hooks/itemCreation/createHooks";
import {
  CreateMaterialInput,
  CreateUploadFileInput,
  UpdateMaterialInput,
  CreateMaterialVariantInput,
  UpdateMaterialVariantInput,
} from "../../../../types/graphQlQuery.interface";
import { MaterialItemFieldInput, MaterialVariantFieldInput } from "../../../../types/ItemsCreation";
import axios from "axios";
import { useFetchImageUrl } from "../../../../apolloClient/hooks/general/fetchHook";
import { uploadImage } from "../../../../redux/api/common";
import { useCreateUploadUrl } from "../../../../apolloClient/hooks/general/createHook";
import ConfirmationDialog from "../../../../components/dialogue/ConfirmationDialog";

interface MaterialMeasurementsTableProps {
  materialItemsData: MaterialItems[];
  refetchMaterials: Function;
  materialMeasurementIds: MaterialMeasurements[];
  tagsData: Tag[];
  permissions?: boolean;
}

const photoSampleData: { photo: string }[] = [
  { photo: "First photo" },
  { photo: "Second photo" },
  { photo: "Third photo" },
];

export const MaterialItemsTable: React.FC<MaterialMeasurementsTableProps> = ({
  materialItemsData,
  materialMeasurementIds,
  tagsData,
  refetchMaterials,
  permissions,
}) => {
  const dispatch = useDispatch();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage] = React.useState(8);
  const [keyword, setKeyword] = React.useState("");

  const inputRef = React.useRef<HTMLInputElement>(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openRowDetailsDrawer, setOpenRowDetailsDrawer] =
    React.useState<boolean>(false);

  const [viewRowDetailsData, setViewRowDetailsData] =
    useState<MaterialItems | null>(null);

  const [materialItem, setMaterialItem] = useState<MaterialItemFieldInput>({
    materialMeasurementParentId: 0,
    name: "",
    brand: "",
    description: "",
    quality: null,
    price: null,
    measurementUnit: "",
    coverageAmount: null,
    forceCustomerSelection: false,
    pictures: [],
    variants: [],
    selectedTags: [],
  });

  const fileRef = useRef<HTMLInputElement>(null);
  const [uploadUrl, setUploadUrl] = useState<string>("");
  const [showMaterialQuality, setShowMaterialQuality] = useState(false);
  const [openPhotoFormDrawer, setOpenPhotoFormDrawer] = useState(false);
  const [openVariantFormDrawer, setOpenVariantFormDrawer] = useState(false);

  const [photosData, setPhotosData] = useState<
    { fileName?: string; fileUrl: string; fileId?: number; }[]
  >([]);

  const [currentVariant, setCurrentVariant] = useState<MaterialVariantFieldInput>({
    color: "",
    image: "",
  });

  const [selectedQualityId, setSelectedQualityId] = useState<number | null>(
    null
  );
  const [photoUploaded, setPhotoUploaded] = useState(false);

  const [fileUrl, setFileUrl] = useState<string>("");

  const { createUploadUrl } = useCreateUploadUrl();

  const { createMaterial } = useCreateMaterial();
  const { updateMaterial } = useUpdateMaterial();
  const { archiveMaterial } = useArchiveMaterial();

  const [openArchieveDialog, setOpenArchieveDialog] = useState(false);
  const [selectedMaterial, setSelectedMaterial] =
    useState<MaterialItems | null>(null);

  const handleArchive = (row: MaterialItems) => {
    setSelectedMaterial(row);
    setOpenArchieveDialog(true);
  };

  const confirmArchieve = async () => {
    if (selectedMaterial) {
      const success = await archiveMaterial(selectedMaterial.id);
      if (success) {
        toast(`${selectedMaterial.name} Archived!`, { type: "error" });
        logEvent(ITEM_CREATION_EVENTS.MATERIAL_ITEM_ARCHIVED, { item_id: selectedMaterial.id, item_name: selectedMaterial.name, timestamp: new Date().toISOString() });
        refetchMaterials();
      } else {
        toast(`Failed to Archive ${selectedMaterial.name}`);
      }
      setOpenArchieveDialog(false);
      setSelectedMaterial(null);
    }
  };

  const cancelArchieve = () => {
    setOpenArchieveDialog(false);
    setSelectedMaterial(null);
  };

  const [editMode, setEditMode] = useState(false);
  const [editingMaterialId, setEditingMaterialId] = useState<number | null>(
    null
  );
  const [removedImages, setRemovedImages] = useState<number[]>([]);

  const getUplaodUrl = async () => {
    const input: CreateUploadFileInput = {
      contentType: "image/jpeg",
    };

    const success = await createUploadUrl(input);
    if (success) {
      setPhotoUploaded(true);
      setUploadUrl(success.url);
      setFileUrl(success.fileName);
      return;
    } else {
      console.error("Failed to create Upload url.");
    }
  };

  const handleSubmitImage = async () => {
    const file = fileRef.current?.files[0];
    const fileName = file?.name;
    if (!file) {
      toast("An image have not been selected", {
        type: "error",
        position: "top-left",
        className: "toast-message",
      });
      return;
    }

    try {
      const result = await uploadImage(uploadUrl, file);
      if (result.success) {
        setPhotosData((prevData) => [
          ...prevData,
          { fileName: fileName, fileUrl: fileUrl },
        ]);
        setOpenPhotoFormDrawer(false);
        setUploadUrl("");
      }
    } catch (error) {
      console.error("Error uploading image ", error);
    }
  };

  const onTapSubmitPhotoForm = async () => {
    await handleSubmitImage();
  };

  const getQualityValue = (id: number): string => {
    return (
      CHECK_MATERIAL_QUALITY.find((quality) => quality.id === id)?.name || ""
    );
  };

  const handleCheckboxChange = (id: number) => {
    setSelectedQualityId(id === selectedQualityId ? null : id);
    setShowMaterialQuality(true);
    const qualityValue = getQualityValue(id);
    setMaterialItem((prevItem) => ({
      ...prevItem,
      quality: qualityValue,
    }));
  };

  const viewRowDetails = (rowData: MaterialItems) => {
    setViewRowDetailsData(rowData);
    handleViewRowDetailsDrawerOpen();
  };

  const handleViewRowDetailsDrawerOpen = () => {
    setOpenRowDetailsDrawer(true);
  };

  const handleViewRowDetailsDrawerClose = () => {
    setOpenRowDetailsDrawer(false);
  };

  const handleChange = (value: string, name: string) => {
    setMaterialItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSearchIconClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const filterMaterialItems = () => {
    if (keyword.length > 0 && Array.isArray(materialItemsData)) {
      // console.log(materialItemsData);
      return materialItemsData.filter((item) => {
        const materialItemsName = `${item.name}`;
        return materialItemsName.toLowerCase().includes(keyword.toLowerCase());
      });
    }
    // console.log(materialItemsData);
    return materialItemsData;
  };

  const goToPreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const goToNextPage = () => {
    setPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(filterMaterialItems().length / rowsPerPage) - 1
      )
    );
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleSelectMaterialMeasurementParentId = (event, selectedFilm) => {
    if (selectedFilm) {
      setMaterialItem((prevItem) => ({
        ...prevItem,
        materialMeasurementParentId: selectedFilm.id,
      }));
    }
  };

  const getMaterialMeasurementParentIdsOptions = (
    sampleDataArray: any[]
  ): { id: number; label: string }[] => {
    return sampleDataArray.map((item) => ({ id: item.id, label: item.name }));
  };

  const handleSetPrice = (value) => {
    if (value) {
      setMaterialItem((prevItem) => ({
        ...prevItem,
        price: value,
      }));
    }
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setEditMode(false);
    setEditingMaterialId(null);
    setRemovedImages([]);
  };

  const handlePhotoDrawerClose = () => {
    setOpenPhotoFormDrawer(false);
  };

  const handleVariantDrawerClose = () => {
    setOpenVariantFormDrawer(false);
    setCurrentVariant({ color: "", image: "" });
    setUploadUrl("");
    setFileUrl("");
  };

  const handleVariantChange = (value: string, field: string) => {
    setCurrentVariant((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  const handleRemoveVariant = (index: number) => {
    setMaterialItem((prev) => ({
      ...prev,
      variants: prev.variants.filter((_, i) => i !== index),
    }));
  };

  const handleDeleteDocument = (imageId: number): void => {
    setPhotosData((prevData) =>
      prevData.filter((item) => item.fileId !== imageId)
    );
  
    if (editMode) {
      setRemovedImages((prev) => [...prev, imageId]); 
    }
  };

  const handleEditMaterial = (material: MaterialItems) => {
    setEditMode(true);
    setEditingMaterialId(material.id);
    setMaterialItem({
      materialMeasurementParentId: material.measurement.id,
      name: material.name,
      brand: material.brand,
      description: material.description,
      quality: material.quality,
      price: material.price,
      measurementUnit: material.measurementUnit,
      coverageAmount: material.coverageAmount,
      forceCustomerSelection: true,
      pictures: material.images,
      variants: material.variants ? material.variants.map(variant => ({
        color: variant.color,
        image: variant.images[0]?.url || "",
      })) : [],
      selectedTags: material.tags?.map(tag => tag.Id) || [],
    });
    setPhotosData(
      material.images.map((image) => ({
        fileId: image.id,
        fileUrl: image.url,
      }))
    );

    const qualityId = CHECK_MATERIAL_QUALITY.find(
      (quality) => quality.name === material.quality
    )?.id;
    setSelectedQualityId(qualityId || null);

    handleDrawerOpen();
  };

  const onTapSubmitForm = async () => {
    const validationRules = [
      {
        condition: !materialItem.name,
        message: "Please Enter the material name",
      },
      {
        condition: !materialItem.description,
        message: "Please Enter the material description",
      },
      {
        condition: !materialItem.price,
        message: "Please Enter the material price",
      },
      {
        condition: !materialItem.measurementUnit,
        message: "Please Enter the material measurement unit",
      },
      {
        condition: !materialItem.coverageAmount,
        message: "Please Enter the material coverage amount",
      },
      {
        condition: !materialItem.brand,
        message: "Please Enter the material brand",
      },
      {
        condition: !materialItem.materialMeasurementParentId,
        message: "Please Select the material measurement parent id",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    if (editMode && editingMaterialId) {
      const newImages = photosData.filter((item) => !item.fileId).map((item) => item.fileUrl);

      const variants: UpdateMaterialVariantInput[] = materialItem.variants.map((variant) => ({
        color: variant.color,
        images: [variant.image],
      }));

      const input: UpdateMaterialInput = {
        id: editingMaterialId,
        name: materialItem.name,
        measurementId: materialItem.materialMeasurementParentId,
        brand: materialItem.brand,
        description: materialItem.description,
        price: materialItem.price,
        quality: materialItem.quality,
        measurementUnit: materialItem.measurementUnit,
        coverageAmount: materialItem.coverageAmount,
        addedImages: newImages.length > 0 ? newImages : [],
        removedImages,
        tagIds: materialItem.selectedTags,
        variants: variants.length > 0 ? variants : undefined,
      };

      const success = await updateMaterial(input);
        if (success) {
          toast("Material items updated successfully.", {
            type: "success",
            className: "toast-message",
            position: "top-left",
          });
          logEvent(ITEM_CREATION_EVENTS.MATERIAL_ITEM_UPDATED, { item_id: selectedMaterial.id, item_name: materialItem.name, timestamp: new Date().toISOString() });
          handleDrawerClose();
          setMaterialItem({
            materialMeasurementParentId: 0,
            name: "",
            brand: "",
            description: "",
            quality: null,
            price: null,
            measurementUnit: "",
            coverageAmount: null,
            forceCustomerSelection: false,
            pictures: [],
            variants: [],
            selectedTags: [],
          });
          setPhotosData([]);
          setSelectedQualityId(null);
          setShowMaterialQuality(false);
          refetchMaterials();
          return;
        } else {
          console.error("Failed to update Material Items.");
        }
      } else {
        const variants: CreateMaterialVariantInput[] = materialItem.variants.map((variant) => ({
          color: variant.color,
          images: [variant.image],
        }));

        const input: CreateMaterialInput = {
          name: materialItem.name,
          measurementId: materialItem.materialMeasurementParentId,
          brand: materialItem.brand,
          description: materialItem.description,
          price: materialItem.price,
          quality: materialItem.quality,
          measurementUnit: materialItem.measurementUnit,
          coverageAmount: materialItem.coverageAmount,
          images: photosData.map((item) => item.fileUrl),
          variants: variants.length > 0 ? variants : undefined,
          tagIds: materialItem.selectedTags,
        };

      const success = await createMaterial(input);
      if (success) {
        toast("Material items created successfully.", {
          type: "success",
          className: "toast-message",
          position: "top-left",
        });
        logEvent(ITEM_CREATION_EVENTS.MATERIAL_ITEM_CREATED, { item_name: materialItem.name, category_id: materialItem.materialMeasurementParentId, timestamp: new Date().toISOString() });
        handleDrawerClose();
        setMaterialItem({
          materialMeasurementParentId: 0,
          name: "",
          brand: "",
          description: "",
          quality: null,
          price: null,
          measurementUnit: "",
          coverageAmount: null,
          forceCustomerSelection: false,
          pictures: [],
          variants: [],
          selectedTags: [],
        });
        setPhotosData([]);
        setSelectedQualityId(null);
        setShowMaterialQuality(false);
        refetchMaterials();
        return;
      } else {
        console.error("Failed to create Material Items.");
      }
    }
  };

  const createVariantFormDrawer = () => {
    return (
      <MaterialItemsDrawer
        open={openVariantFormDrawer}
        onClose={() => setOpenVariantFormDrawer(false)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            height: "80%",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => setOpenVariantFormDrawer(false)}
            labelTitle="Add material variant"
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "97%",
                marginRight: "3%",
                justifyContent: "space-between",
              }}
            >
              <ColDiv
                style={{
                  marginTop: "20px",
                  gap: "15px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  <FormTitleTypography>Color</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter variant color"
                  onChange={(value) => handleVariantChange(value, "color")}
                  required={true}
                  value={currentVariant.color}
                  name="color"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    width: "50%",
                    marginX: "2%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "60%",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "white",
                    }}
                  >
                    <Lbl
                      title={
                        photoUploaded
                          ? "Click save to complete"
                          : "Upload Variant Image"
                      }
                      size={16}
                      backgroundColor="white"
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "40%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SFileUpload
                      style={{
                        border: "none",
                        marginLeft: 10,
                        height: "35px",
                        width: "100px",
                        backgroundColor: "white",
                      }}
                      onClick={() => {
                        if (fileRef.current) {
                          fileRef.current.click();
                        }
                      }}
                    >
                      <input
                        type="file"
                        id="file"
                        ref={fileRef}
                        onChange={() => {
                          if (uploadUrl === "") {
                            getUplaodUrl();
                          }
                        }}
                        accept={"image/png, image/jpeg, image/jpg"}
                        style={{
                          display: "none",
                        }}
                      />
                      <FileOpen
                        titleAccess="Select File"
                        color="warning"
                        style={{
                          width: 32,
                          height: 32,
                          color: AppCSS.GLAS_GREEN,
                        }}
                      />
                    </SFileUpload>
                  </Box>
                </Box>
                <Spacer size={1} direction="col" />
              </ColDiv>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleVariantDrawerClose}
          onCreate={async () => {
            if (uploadUrl && fileUrl && currentVariant.color) {
              const file = fileRef.current?.files[0];
              if (file) {
                try {
                  const result = await uploadImage(uploadUrl, file);
                  if (result.success) {
                    const newVariant = {
                      color: currentVariant.color,
                      image: fileUrl
                    };
                    setMaterialItem((prev) => ({
                      ...prev,
                      variants: [...prev.variants, newVariant],
                    }));
                    handleVariantDrawerClose();
                  }
                } catch (error) {
                  console.error("Error uploading variant image ", error);
                }
              }
            }
          }}
          submitText="Save variant"
          isDisabled={!currentVariant.color || uploadUrl === ""}
          bgColor={!currentVariant.color || uploadUrl === "" ? AppCSS.GRAY_MILD : AppCSS.GLAS_GREEN}
        />
      </MaterialItemsDrawer>
    );
  };

  const createPhotoFormDrawer = () => {
    return (
      <MaterialItemsDrawer
        open={openPhotoFormDrawer}
        onClose={() => setOpenPhotoFormDrawer(false)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            height: "80%",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => setOpenPhotoFormDrawer(false)}
            labelTitle="Upload photo of material"
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "97%",
                marginRight: "3%",
                justifyContent: "space-between",
              }}
            >
              <ColDiv
                style={{
                  marginTop: "20px",
                }}
              >
                <Box
                  sx={{
                    width: "50%",
                    marginX: "2%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",

                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "60%",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "white",
                    }}
                  >
                    <Lbl
                      title={
                        photoUploaded
                          ? "Click save to complete"
                          : "Upload Photo"
                      }
                      size={16}
                      backgroundColor="white"
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "40%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SFileUpload
                      style={{
                        border: "none",
                        marginLeft: 10,
                        height: "35px",
                        width: "100px",
                        backgroundColor: "white",
                      }}
                      onClick={() => {
                        if (fileRef.current) {
                          fileRef.current.click();
                        }
                      }}
                    >
                      <input
                        type="file"
                        id="file"
                        ref={fileRef}
                        onChange={() => {
                          if (uploadUrl === "") {
                            getUplaodUrl();
                          }
                        }}
                        accept={"image/png, image/jpeg, image/jpg"}
                        style={{
                          display: "none",
                        }}
                      />
                      <FileOpen
                        titleAccess="Select File"
                        color="warning"
                        style={{
                          width: 32,
                          height: 32,
                          color: AppCSS.GLAS_GREEN,
                        }}
                      />
                    </SFileUpload>
                  </Box>
                </Box>
                <Spacer size={1} direction="col" />
              </ColDiv>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handlePhotoDrawerClose}
          onCreate={onTapSubmitPhotoForm}
          submitText="Save photo"
          isDisabled={uploadUrl === "" ? true : false}
          bgColor={uploadUrl === "" ? AppCSS.GRAY_MILD : AppCSS.GLAS_GREEN}
        />
      </MaterialItemsDrawer>
    );
  };

  const createMaterialItemsForm = () => {
    return (
      <MaterialItemsDrawer
        open={openDrawer}
        onClose={() => handleDrawerClose()}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={handleDrawerClose}
            labelTitle={editMode ? "Edit material" : "Create new material"}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "97%",
                marginRight: "3%",
                justifyContent: "space-between",
              }}
            >
              <ColDiv
                style={{
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  <FormTitleTypography>Name</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter material name"
                  onChange={handleChange}
                  required={true}
                  value={materialItem.name}
                  name="name"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <FormTitleTypography
                  style={{
                    display: "felx",
                    width: "60%",
                    justifyContent: "start",
                    textAlign: "start",
                  }}
                >
                  Select associated material measurement
                </FormTitleTypography>
                <Box
                  sx={{
                    width: "96%",
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    background: "inherit",
                    borderRadius: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "end",
                      width: "100%",
                    }}
                  >
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={getMaterialMeasurementParentIdsOptions(
                        materialMeasurementIds
                      )}
                      sx={{ width: "100%" }}
                      onChange={handleSelectMaterialMeasurementParentId}
                      value={
                        materialMeasurementIds
                          ?.map((measurement) => ({
                            id: measurement.id,
                            label: measurement.name,
                          }))
                          .find(
                            (measurement) =>
                              measurement.id ===
                              materialItem.materialMeasurementParentId
                          ) || null
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="Search measurement" />
                      )}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <FormTitleTypography>Brand</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter brand's name"
                  onChange={handleChange}
                  required={true}
                  value={materialItem.brand}
                  name="brand"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <FormTitleTypography>Description</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter a description"
                  onChange={handleChange}
                  required={true}
                  value={materialItem.description}
                  name="description"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  lines={4}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "start",
                    marginTop: "5px",
                    width: "98%",
                    marginRight: "2%",
                  }}
                >
                  <RowDiv
                    style={{
                      gap: "10px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                        alignItems: "start",
                        justifyContent: "start",
                        gap: "10px",
                      }}
                    >
                      {" "}
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          cursor: "pointer",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <FormTitleTypography>Price</FormTitleTypography>
                      </Box>
                      <TxtInput
                        type={"number"}
                        placeholder="Enter price"
                        onChange={(item) => handleSetPrice(item)}
                        required={true}
                        value={materialItem.price}
                        name="price"
                        background="inherit"
                        borderColor="rgba(173, 173, 173, 1)"
                        borderRadius={10}
                        height={50}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          cursor: "pointer",
                          justifyContent: "start",
                          alignItems: "center",
                          gap: "30px",
                        }}
                      >
                        <FormTitleTypography>
                          Measurement Unit
                        </FormTitleTypography>
                      </Box>
                      <TxtInput
                        placeholder="Enter unit"
                        onChange={handleChange}
                        required={true}
                        value={materialItem.measurementUnit}
                        name="measurementUnit"
                        background="inherit"
                        borderColor="rgba(173, 173, 173, 1)"
                        borderRadius={10}
                        height={50}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                        alignItems: "start",
                        justifyContent: "start",
                        gap: "10px",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          cursor: "pointer",
                          justifyContent: "start",
                          alignItems: "center",
                          marginTop: "5px",
                        }}
                      >
                        <FormTitleTypography>Quality</FormTitleTypography>
                      </Box>

                      <Box
                        sx={{
                          width: "96%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "inherit",
                          borderRadius: "10px",
                          border: "1px solid rgba(173, 173, 173, 1)",
                          height: "fit-content",
                          minHeight: "50px",
                          paddingY: "10px",
                        }}
                        onClick={() =>
                          setShowMaterialQuality(!showMaterialQuality)
                        }
                      >
                        <RowDiv
                          style={{
                            width: "100%",
                            paddingLeft: "20px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              width: "60%",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Lbl
                              title="Select a Quality"
                              size={16}
                              mobileFontSize={16}
                              isFullWidth={true}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              width: "40%",
                              alignItems: "center",
                              justifyContent: "end",
                              paddingRight: "20px",
                            }}
                          >
                            {showMaterialQuality ? (
                              <ArrowIcon src={UpArrowIcon} />
                            ) : (
                              <ArrowIcon src={DownArrowIcon} />
                            )}
                          </Box>
                        </RowDiv>

                        {showMaterialQuality && (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              cursor: "pointer",
                              justifyContent: "center",
                              alignItems: "start",
                              width: "100%",
                              paddingX: "20px",
                            }}
                          >
                            {CHECK_MATERIAL_QUALITY.map((item) => (
                              <Box
                                key={`checkProductsSystemParent ${item.id}`}
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  cursor: "pointer",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                }}
                              >
                                <ChkInputBox
                                  onChange={(value: boolean) => {
                                    handleCheckboxChange(item.id);
                                  }}
                                  placeholder=""
                                  width={50}
                                  marginTop={0}
                                  marginBottom={0}
                                  height={20}
                                  background="inherit"
                                  checked={item.id === selectedQualityId}
                                />
                                <Typography>{item.name}</Typography>
                              </Box>
                            ))}
                          </Box>
                        )}
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          cursor: "pointer",
                          justifyContent: "start",
                          alignItems: "center",
                          gap: "10px",
                          marginTop: "5px",
                        }}
                      >
                        <FormTitleTypography>
                          Coverage Amount
                        </FormTitleTypography>
                      </Box>
                      <TxtInput
                        placeholder="Enter amount"
                        onChange={handleChange}
                        required={true}
                        value={materialItem.coverageAmount}
                        name="coverageAmount"
                        background="inherit"
                        borderColor="rgba(173, 173, 173, 1)"
                        borderRadius={10}
                        height={50}
                      />
                    </Box>
                  </RowDiv>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    marginTop: "20px",
                  }}
                >
                  <FormTitleTypography style={{ textAlign: 'left' }}>Tags</FormTitleTypography>
                <Autocomplete
                    multiple
                    options={tagsData}
                    getOptionLabel={(option) => option.tagName}
                    value={tagsData.filter(tag => materialItem.selectedTags.includes(tag.Id))}
                    onChange={(event, newValue) => {
                      setMaterialItem({
                        ...materialItem,
                        selectedTags: newValue.map(tag => tag.Id)
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select tags"
                        sx={{
                          width: '100%',
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '5px',
                            backgroundColor: AppCSS.GRAY_MILD,
                            border: 'none',
                            minHeight: '45px',
                            paddingLeft: '10px',
                            '& fieldset': {
                              border: 'none',
                            },
                            '&:hover fieldset': {
                              border: 'none',
                            },
                            '&.Mui-focused fieldset': {
                              border: 'none',
                            },
                          },
                          '& .MuiOutlinedInput-input': {
                            padding: '8px 4px 8px 0px',
                          }
                        }}
                      />
                    )}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Box
                          key={option.Id}
                          {...getTagProps({ index })}
                          sx={{
                            backgroundColor: AppCSS.BLUE,
                            color: AppCSS.WHITE,
                            borderRadius: '20px',
                            padding: '4px 12px',
                            margin: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '12px',
                          }}
                        >
                          {option.tagName}
                          <Box
                            onClick={() => {
                              const newSelectedTags = materialItem.selectedTags.filter(id => id !== option.Id);
                              setMaterialItem({
                                ...materialItem,
                                selectedTags: newSelectedTags
                              });
                            }}
                            sx={{
                              marginLeft: '8px',
                              cursor: 'pointer',
                              fontSize: '16px',
                              fontWeight: 'bold',
                            }}
                          >
                            ×
                          </Box>
                        </Box>
                      ))
                    }
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <FormTitleTypography>Photo</FormTitleTypography>
                  <StandardIcon
                    src={plusIcon}
                    onClick={() => {
                      setOpenPhotoFormDrawer(true);
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    paddingY: "10px",
                  }}
                >
                  {photosData.map((row, rowIndex) => (
                    <PicturesTableWithoutHeader
                      key={`Material items photo ${rowIndex}`}
                      bodyContent={[
                        {
                          text: (
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                              <a
                                href={`${row.fileUrl}`}
                                target="_blank"
                                style={{
                                  fontSize: 15,
                                  color: AppCSS.GLAS_BLUE,
                                }}
                                rel="noreferrer"
                                download={false}
                              >
                                <p>{`Image ${rowIndex+1}`}</p>
                              </a>
                              <StandardIcon
                                src={deleteIcon}
                                style={{cursor: "pointer", marginLeft: "10px"}}
                                onClick={() => {
                                  handleDeleteDocument(row.fileId);
                                }}
                              />
                            </div>
                          ),
                          width: "20%",
                          fontSize: "15px",
                        },
                      ]}
                    />
                  ))}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                    marginTop: "20px",
                  }}
                >
                  <FormTitleTypography>Variants</FormTitleTypography>
                  <StandardIcon
                    src={plusIcon}
                    onClick={() => {
                      setOpenVariantFormDrawer(true);
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    paddingY: "10px",
                  }}
                >
                  {materialItem.variants.map((variant, index) => (
                    <PicturesTableWithoutHeader
                      key={`Material variant ${index}`}
                      bodyContent={[
                        {
                          text: (
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                              <span style={{ fontSize: 15 }}>
                                {variant.color}
                              </span>
                              <a
                                href={variant.image}
                                target="_blank"
                                style={{
                                  fontSize: 15,
                                  color: AppCSS.GLAS_BLUE,
                                }}
                                rel="noreferrer"
                              >
                                View Image
                              </a>
                              <StandardIcon
                                src={deleteIcon}
                                style={{cursor: "pointer", marginLeft: "10px"}}
                                onClick={() => handleRemoveVariant(index)}
                              />
                            </div>
                          ),
                          width: "100%",
                          fontSize: "15px",
                        },
                      ]}
                    />
                  ))}
                </Box>
              </ColDiv>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleDrawerClose}
          onCreate={onTapSubmitForm}
          submitText={ editMode ? "Update" : "Create"}
        />
      </MaterialItemsDrawer>
    );
  };

  const picturesTable = (value: any) => {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "start",
        }}
      >
        {value.map((row, rowIndex) => (
          <MaterialItemsProductSystemTableWithoutHeader
            key={`material items pictures ${rowIndex}`}
            bodyContent={[
              {
                text: (
                  <a
                    href={`${row.url}`}
                    target="_blank"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "start",
                      alignItems: "center",
                      fontSize: 15,
                      color: AppCSS.GLAS_BLUE,
                    }}
                    rel="noreferrer"
                    download={false}
                  >
                    <p>{`Image ${rowIndex+1}`}</p>
                  </a>
                ),
                width: "100%",
                fontSize: "14px",
                paddingLeft: "50px",
              },
            ]}
          />
        ))}
      </Box>
    );
  };

  const variantsTable = (value: any) => {
    if (!value || value.length === 0) {
      return (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <p style={{ fontSize: 14, color: "#666" }}>No variants available</p>
        </Box>
      );
    }

    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "start",
        }}
      >
        {value.map((variant, variantIndex) => (
          <MaterialItemsProductSystemTableWithoutHeader
            key={`material variant ${variantIndex}`}
            bodyContent={[
              {
                text: (
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <div style={{ fontSize: 15, fontWeight: "bold" }}>
                      Color: {variant.color}
                    </div>
                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                      {variant.images && variant.images.length > 0 ? (
                        variant.images.map((image, imageIndex) => (
                          <a
                            key={`variant-image-${imageIndex}`}
                            href={image.url}
                            target="_blank"
                            style={{
                              fontSize: 14,
                              color: AppCSS.GLAS_BLUE,
                              textDecoration: "underline",
                            }}
                            rel="noreferrer"
                          >
                            Image {imageIndex + 1}
                          </a>
                        ))
                      ) : (
                        <span style={{ fontSize: 14, color: "#666" }}>No images</span>
                      )}
                    </div>
                  </div>
                ),
                width: "100%",
                fontSize: "14px",
                paddingLeft: "50px",
              },
            ]}
          />
        ))}
      </Box>
    );
  };

  const showMaterialItemsRowDetails = () => {
    return (
      <ViewRowDetailsDrawer
        openDrawer={openRowDetailsDrawer}
        handleDrawerClose={handleViewRowDetailsDrawerClose}
        rowDetailsData={viewRowDetailsData}
        labelTitle="Material Items Details"
        rowArrayTableComponent={picturesTable}
        rowArrayTableComponentThree={variantsTable}
        detailsOfRowToBeDisplay={MATERIAL_ITEMS_DRAWER_DETAILS}
      />
    );
  };

  const MaterialItemsTable = () => {
    const paginatedData = filterMaterialItems().slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    const totalPages = Math.ceil(filterMaterialItems().length / rowsPerPage);

    return (
      <Box sx={{ width: "100%" }}>
        {/* Search and Create Button */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", md: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              height: "44px",
              width: { xs: "100%", md: "320px" },
              transition: "border-color 0.2s, box-shadow 0.2s",
              "&:focus-within": {
                borderColor: "#4b87ed",
                boxShadow: "0 0 0 3px rgba(75, 135, 237, 0.1)",
              },
            }}
          >
            <Box
              component="img"
              src={searchIcon}
              sx={{ width: 16, height: 16, cursor: "pointer", margin: "0 12px" }}
              onClick={handleSearchIconClick}
            />
            <TxtInput
              placeholder="Search materials"
              onChange={setKeyword}
              inputRef={inputRef}
              background="white"
              width="100%"
            />
          </Box>

          {permissions && (
            <Box
              component="button"
              onClick={() => {
                handleDrawerOpen();
                setEditMode(false);
                setEditingMaterialId(null);
                setRemovedImages([]);
                setMaterialItem({
                  materialMeasurementParentId: 0,
                  name: "",
                  brand: "",
                  description: "",
                  quality: null,
                  price: null,
                  measurementUnit: "",
                  coverageAmount: null,
                  forceCustomerSelection: false,
                  pictures: [],
                  variants: [],
                  selectedTags: [],
                });
                setPhotosData([]);
                setSelectedQualityId(null);
                setShowMaterialQuality(false);
              }}
              sx={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
                backgroundColor: "#4b87ed",
                color: "white",
                border: "none",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#3a6fd8",
                },
              }}
            >
              + Create new material
            </Box>
          )}
        </Box>

        {/* Table */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Desktop Table Header */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              padding: "14px 20px",
              backgroundColor: "#f3f4f6",
              borderBottom: "1px solid #e5e7eb",
              fontWeight: 600,
              fontSize: 12,
              color: "#6b7280",
              textTransform: "uppercase",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "8%", minWidth: "50px" }}>ID</Box>
            <Box sx={{ width: "22%", minWidth: "100px" }}>Name</Box>
            <Box sx={{ width: "18%", minWidth: "80px" }}>Brand</Box>
            <Box sx={{ width: "12%", minWidth: "60px" }}>Price</Box>
            <Box sx={{ width: "12%", minWidth: "60px" }}>Unit</Box>
            <Box sx={{ width: "28%", minWidth: "150px", textAlign: "right" }}>Actions</Box>
          </Box>

          {/* Table Body */}
          {filterMaterialItems().length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "48px 24px",
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: 15, color: "#6b7280", margin: 0 }}>
                No material items available
              </Typography>
            </Box>
          ) : (
            paginatedData.map((row, rowIndex) => (
              <Box
                key={`material-item-${rowIndex}`}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-start", md: "center" },
                  padding: { xs: "14px 16px", md: "14px 20px" },
                  borderBottom: "1px solid #f0f0f0",
                  gap: { xs: 1, md: 0 },
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&:last-child": {
                    borderBottom: "none",
                  },
                }}
              >
                {/* ID */}
                <Box sx={{ width: { xs: "100%", md: "8%" }, minWidth: { md: "50px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    ID
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#1a1a2e" }}>
                    {row.id}
                  </Typography>
                </Box>

                {/* Name */}
                <Box sx={{ width: { xs: "100%", md: "22%" }, minWidth: { md: "100px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Name
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {row.name}
                  </Typography>
                </Box>

                {/* Brand */}
                <Box sx={{ width: { xs: "100%", md: "18%" }, minWidth: { md: "80px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Brand
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {row.brand}
                  </Typography>
                </Box>

                {/* Price */}
                <Box sx={{ width: { xs: "100%", md: "12%" }, minWidth: { md: "60px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Price
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    ${row.price}
                  </Typography>
                </Box>

                {/* Unit */}
                <Box sx={{ width: { xs: "100%", md: "12%" }, minWidth: { md: "60px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Unit
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {row.measurementUnit}
                  </Typography>
                </Box>

                {/* Actions */}
                <Box
                  sx={{
                    width: { xs: "100%", md: "28%" },
                    minWidth: { md: "150px" },
                    display: "flex",
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    gap: 1,
                    flexWrap: "wrap",
                    marginTop: { xs: 1, md: 0 },
                  }}
                >
                  <Box
                    component="button"
                    onClick={() => viewRowDetails(row)}
                    sx={{
                      padding: "8px 16px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      backgroundColor: "#e5e7eb",
                      color: "#374151",
                      border: "none",
                      "&:hover": {
                        backgroundColor: "#d1d5db",
                      },
                    }}
                  >
                    View
                  </Box>
                  {permissions && (
                    <>
                      <Box
                        component="button"
                        onClick={() => handleEditMaterial(row)}
                        sx={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: 500,
                          cursor: "pointer",
                          transition: "all 0.2s",
                          backgroundColor: "#e5e7eb",
                          color: "#374151",
                          border: "none",
                          "&:hover": {
                            backgroundColor: "#d1d5db",
                          },
                        }}
                      >
                        Edit
                      </Box>
                      <Box
                        component="button"
                        onClick={() => handleArchive(row)}
                        sx={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: 500,
                          cursor: "pointer",
                          transition: "all 0.2s",
                          backgroundColor: "#fee2e2",
                          color: "#dc2626",
                          border: "none",
                          "&:hover": {
                            backgroundColor: "#fecaca",
                          },
                        }}
                      >
                        Archive
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            ))
          )}

          {/* Pagination */}
          {filterMaterialItems().length > 0 && totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-end" },
                padding: "14px 20px",
                gap: 1,
                borderTop: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
              }}
            >
              <Box
                component="button"
                onClick={goToPreviousPage}
                disabled={page === 0}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page === 0 ? "#f3f4f6" : "#e5e7eb",
                  color: page === 0 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page === 0 ? "not-allowed" : "pointer",
                  "&:hover": page === 0 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                ← Prev
              </Box>
              <Typography sx={{ fontSize: 14, color: "#6b7280", margin: "0 8px" }}>
                Page {page + 1} of {totalPages}
              </Typography>
              <Box
                component="button"
                onClick={goToNextPage}
                disabled={page >= totalPages - 1}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page >= totalPages - 1 ? "#f3f4f6" : "#e5e7eb",
                  color: page >= totalPages - 1 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page >= totalPages - 1 ? "not-allowed" : "pointer",
                  "&:hover": page >= totalPages - 1 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                Next →
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const materialItemsTableContainer = () => {
    return (
      <Box sx={{ width: "100%" }}>
        {Array.isArray(materialItemsData) && MaterialItemsTable()}
        {createMaterialItemsForm()}
        {showMaterialItemsRowDetails()}
        {createPhotoFormDrawer()}
        {createVariantFormDrawer()}
      </Box>
    );
  };

  return (
    <>
      {materialItemsTableContainer()}
      <ConfirmationDialog
        open={openArchieveDialog}
        title="Confirm Archive"
        message={`Are you sure you want to Archive "${selectedMaterial?.name}"?`}
        onConfirm={confirmArchieve}
        onCancel={cancelArchieve}
      />
    </>
  );
};
